<template>
  <div id="user">
    <p class="title"><label @click="$router.push('/user/home')" style="font-size:16px;ont-weight:900;color:green;">我的 / </label>订单审核</p>
    <div class="common-search-box">
      <div>
      </div>
      <div>
        <el-input placeholder="订单号、商品名称"  v-model="query.name" size="small" style="width: 200px"></el-input>
        <button class="common-btn-primary" @click="getOrderQuery">查询</button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" 
       border
       style="width: 100%">
        <el-table-column prop="id" label="订单号" min-width="2"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="订单名" min-width="4">
          <template slot-scope="scope">
            {{scope.row.name ? scope.row.name : scope.row.orderName}}
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="下单账号" min-width="3"></el-table-column>
        <el-table-column prop="createTime" label="下单时间" min-width="3"></el-table-column>
        <el-table-column prop="money" label="金额（元）" min-width="2"></el-table-column>
        <el-table-column prop="consignee" label="收货人" min-width="2"></el-table-column>
        <el-table-column prop="orderStatus" label="状态" min-width="2">
            <el-tag type="danger">待审核</el-tag>
        </el-table-column>
        <el-table-column prop="id" label="操作" min-width="5">
          <template slot-scope="scope">
            <el-popconfirm  title="确认通过该订单？" @confirm="doConfirm(scope.row.id)">
              <button class="common-btn" slot="reference">审核</button>
            </el-popconfirm>
            <button
              class="common-btn"
              @click="$router.push('/order/detailAudit?id='+scope.row.id)"
            >详情</button>
            <el-popconfirm  title="确认取消订单？" @confirm="cancel(scope.row.id)">
              <button class="common-btn-cancel" slot="reference">取消</button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { orderAuditList, orderAudit, cancelOrder } from "@/js/api";
import {
  orderStatusList
} from "@/js/goods"

export default {
  name: "orderlist",
  computed: {},
  data() {
    return {
      query: {
        key: '',
        pageNo: 0,
        pageSize: 10,
        orderStatus: this.$route.query.orderStatus || "",
        createTime: "",
        endTime: "",
        searchTime: []
      },
      total: 0,
      statusList: orderStatusList,
      tableData: []
    };
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getOrder();
    },
    handleCurrentChange(e) {
      this.query.pageNo = e;
      this.getOrder();
    },
    getOrder() {
      orderAuditList({
        ...this.query
      }).then(res => {
        if (res.code == 200 && res.result) {
          const list = (res.result && res.result.records) || [];
          this.total = res.result.total || 0;
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getOrderQuery(){
      this.query.pageNo = 0
      this.getOrder()
    },
    changeQueryTime(e) {
      if (!e) {
        this.query.createTime = "";
        this.query.endTime = "";
        return;
      }
      this.query.createTime = this.formatTime(e[0]) + " 00:00:00";
      this.query.endTime = this.formatTime(e[1]) + " 23:59:59";
    },
    formatTime(time) {
      return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
    },
    doConfirm(id) {
      orderAudit({
          orderId: id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.getOrder();
          } else {
            this.$message.error(res.message);
          }
        });   
    },
    cancel(id) {
      cancelOrder({
        id: id
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getOrder();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  
</style>
